module.exports = __webpack_public_path__ + "media/images/emblems/Perroy-coat_of_arms-3cce6d20507ed7ff19d16b74f26f05ee.svg";